import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'

export const tenantApartmentRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
  RealEstateFeatures.CERTIFICATE_OF_ELIGIBILITY_NEEDED,
]

export const webViewTenantApartmentRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.SHARED_GARDEN,
]

export const tenantApartmentRentEstateFeatures = () => estateFeatures(tenantApartmentRentEstateFeaturesList)

export const createTenantApartmentRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(webViewTenantApartmentRentEstateFeaturesList, label, className)

export const tenantApartmentRentBuildingTypeOptions = [
  BuildingTypeOption.ATTIC,
  BuildingTypeOption.GROUND_FLOOR,
  BuildingTypeOption.APARTMENT,
  BuildingTypeOption.ENTRESOL,
  BuildingTypeOption.LOFT,
  BuildingTypeOption.DUPLEX,
  BuildingTypeOption.PENTHOUSE,
  BuildingTypeOption.BASEMENT,
  BuildingTypeOption.TERRACE,
  BuildingTypeOption.OTHER,
]
